import { Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

/** The console's `/vault` has no page of its own: it opens the dashboard (PRD §14.1, XBIT-4246). */
export const VAULT_ROOT_PATH = '/vault';

const VaultRootRedirect = () => <Navigate to={paths.dashboard.vaultDashboard.root} replace />;

export default VaultRootRedirect;
